<template>
    <v-row no-gutters>
    
    <v-tabs grow icons-and-text v-model="tabs">
            <v-tab id="pfid1665223185"  href="#variants" v-if="hasCopyableVariants">{{$t('campaigns.design.copyVariant.title')}} <v-icon>$variants</v-icon></v-tab>
            <v-tab id="pfid1618820650" href="#templates">{{$t('campaigns.design.templates.title')}} <v-icon>$templateGallery</v-icon></v-tab>
            <v-tab id="pfid1618820653" href="#existing">{{$t('campaigns.design.existing.title')}} <v-icon>$copy</v-icon></v-tab>
    </v-tabs>

       
        <v-col cols="12">
        <v-tabs-items v-model="tabs">
            <v-tab-item 
        class="pfcl1619000505" 
        value="variants"
        v-if="hasCopyableVariants">
        
            <v-row>
        <!--
                  <v-col cols="6">
        <v-card>
            <v-card-title>Ahoj</v-card-title>
        </v-card>
    </v-col>
    <v-col cols="6">
        <v-card>
            <v-card-title>Ahoj</v-card-title>
        </v-card>
    </v-col>
    -->
                 <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="d in copyableVariants" :key="d.id">
                    <v-card link @click="duplicateVariantDesign(d)"  class="fill-height">
                        <campaign-preview :html="d.preview" :columns="previewColumns"/>
                        <v-card-title class="justify-center"><v-icon :color="d.active? 'success' : 'grey'">$campaignVariant{{d.name}}</v-icon></v-card-title>
                    </v-card>
                </v-col>
                </v-row>
            <!-- </v-row> -->
      </v-tab-item>
            <v-tab-item
                class="pfcl1619000498" 
             value="templates">
            <v-row v-if="templates">
                <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="t in templates" :key="t.id">
                    <v-card link @click="selectTemplate(t.id)" class="fill-height">
                        <v-img :src="t.preview"></v-img>
                        <v-card-title>{{ t.name }}</v-card-title>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="templatesNextToken">
                    <v-btn color="primary" @click="loadTemplates"><v-icon left>$refresh</v-icon>{{$t('common.loadMore')}}</v-btn>
                </v-col>
            </v-row>
            
        </v-tab-item>
        <v-tab-item 
        class="pfcl1619000505" 
        value="existing">
            <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="d in existingDesigns" :key="d.id">
                    <v-card link @click="duplicateVariantDesign(d)"  class="fill-height">
                        <campaign-preview :html="d.preview" :columns="previewColumns"/>
                        <v-card-title><v-icon left :color="getCampaignStateColor(d.campaign.state)">{{ edIcon(d.campaign.scheduleType) }}</v-icon>{{ d.campaign.domain.name }} &ndash; {{ d.campaign.name }} <v-icon>$campaignVariant{{d.name}}</v-icon></v-card-title>
                    </v-card>
                </v-col>
                 <v-col cols="12" sm="6" md="4" lg="4" xl="3" v-for="d in existingDesignsLegacy" :key="d.id">
                    <v-card link @click="duplicateDesign(d)"  class="fill-height">
                        <campaign-preview :html="d.preview" :columns="previewColumns"/>
                        <v-card-title><v-icon left :color="getCampaignStateColor(d.state)">{{ edIcon(d.scheduleType) }}</v-icon>{{ d.domain.name }} &ndash; {{ d.name }}</v-card-title>
                    </v-card>
                </v-col>
            </v-row>
      </v-tab-item>
    </v-tabs-items>
        </v-col>
    </v-row>
</template>
<script>

import CampaignPreview from '@/components/CampaignPreview'
import Formatters from "@/mixins/formatters"
import { mapState } from "vuex";

export default {
    name: 'TemplateSelector',
    components: {
        CampaignPreview
    },
    mixins: [Formatters],
    props: { variants: Boolean, campaign: String },
    data() {
        return {
            tabs: null
        }
    },
    computed: {
        previewColumns() {
            let columns;
            switch(this.$vuetify.breakpoint.name) {
                case 'xl': columns = 4; break;
                case 'lg': columns = 3; break;
                case 'md': columns = 2; break;
                case 'sm': columns = 2; break;
                case 'xs': columns = 1; break;
            }
            return columns;
        },
        hasCopyableVariants() {
            return this.variants && this.copyableVariants?.length
        },
        copyableVariants() {
            return this.existingVariants?.filter(v => !!v.preview)
        },
        hasLegacyCampaigns() {
            // harcoded date of campaign variants deployment
            return this.existingDesigns?.length == 0 || this.existingDesigns?.some(d=> d?.campaign.domain.createdAt < '2022-11-01')
        },
        ...mapState('nstemplates', { templates: 'list', template: 'item', templatesNextToken: 'nextToken', templatesPublic: 'publicOnly' }),
        ...mapState('campaigns', {existingDesignsLegacy: 'existingDesigns' }),
        ...mapState('variants', { existingVariants: 'list', existingDesigns: 'existingDesigns' }),
    },
    methods: {
        edIcon(type) {
            switch(type) {
                case 'SCHEDULED': return '$scheduled';
                case 'AUTOMATIC': return '$refresh';
                case 'BACK_TO_CART': return '$cart';
            }
        },
        selectTemplate(id) {
            this.$store.dispatch('nstemplates/get', { id}).then(template => {
                //console.debug('Loading template...', template);
                //this.fields.templateUnlayer = template.unlayerData;
                this.$emit('select', template.unlayerData);
            });
        },
        duplicateDesign(d) {
            //this.fields.templateUnlayer = d.templateUnlayer;
            this.$emit('select', d.templateUnlayer);
        },

        async duplicateVariantDesign(v) {
            let r = await this.$store.dispatch('variants/get', { id: v.id, noStore: true});
            this.$emit('select', r.templateUnlayer);
        },

        loadTemplates() {
            if(!this.templates || !this.templatesPublic) {
                this.$store.dispatch('nstemplates/list', { public: true });
                // this is the first load
                return;
            }
            if(this.templatesNextToken) {
                this.$store.dispatch('nstemplates/list', { public: true, nextToken: this.templatesNextToken });
            }
        },
        async loadCampaigns() {
            if(!this.existingDesigns) {
                await this.$store.dispatch('variants/existingDesigns', { /*domainID: this.item.domainID*/ });
                if(this.hasLegacyCampaigns) {
                    // this fills the existingDesignsLegacy vuex binding
                    await this.$store.dispatch('campaigns/existingDesigns', { /*domainID: this.item.domainID*/ });
                }
            }
        },
        async loadVariants() {
            //if(this.variants && !this.existingVariants) {
                // refresh every time so new variants are loaded when added
                await this.$store.dispatch('variants/list', { campaignID: this.campaign })
                if(this.hasCopyableVariants) {
                    this.tabs = 'variants';
                }
            //}
        }
    },
    created() {
        this.loadTemplates();
        this.loadCampaigns();
        this.loadVariants();
    }
}
</script>